import { render } from "./Companies.vue?vue&type=template&id=ce6f5c56"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"
script.render = render

export default script